import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_mst_attribute_hdr_RowClass } from '../../../dbschema/bl_fi_mst_attribute_hdr.model';
import { bl_fi_mst_attribute_ext_RowClass } from '../../../dbschema/bl_fi_mst_attribute_ext.model';

export class AttributeContainerModel extends BaseContainerModel {
  bl_fi_mst_attribute_hdr: bl_fi_mst_attribute_hdr_RowClass = new bl_fi_mst_attribute_hdr_RowClass();
  bl_fi_mst_attribute_ext: bl_fi_mst_attribute_ext_RowClass[] = [];
}